import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BackendService } from '../../../core/services/backend/backend.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ListGameService {
  http = inject(HttpClient);
  private backend = inject(BackendService);


  constructor() { }

  getListRooms(myroom: boolean = false):Observable<any>{
    let url = (myroom)?`${this.backend.getApiUrl()}/rooms?filter=my-rooms`:`${this.backend.getApiUrl()}/rooms`
    return this.http.get<any>(url);
  }
}
